<script setup lang="ts">
import type { JobSlider } from '~/models/Strapi'
import type { JobItem } from '~/models/Job'

interface Props {
  datas: JobSlider
}

const props = defineProps<Props>()
const result = ref()
const breakpoints = {
  300: {
    itemsToShow: 1.1,
  },
  640: {
    itemsToShow: 2,
  },
  1024: {
    itemsToShow: 2,
  },
}

getJobList(props.datas?.keyword)
async function getJobList(keyword: string) {
  const { data, error } = await useSearchApi('/jobs/search', {
    method: 'POST',
    body: {
      country: useGetSubdomain(),
      city: '',
      types: ['full_time', 'part_time', 'freelance', 'internship'],
      remote: '',
      term: keyword,
      from: 0,
      size: 6,
      sort: 'date',
      type: 'simple_title_with_similar_titles_search',
    },
  })
  const resp = data?.value as { total: number; hits: JobItem[] }
  if (resp.total > 0)
    result.value = resp.hits
}
</script>

<template>
  <div v-if="!isEmpty(result)">
    <div class="font-bold mb-4">
      {{ props.datas?.title }}
    </div>

    <div id="carousel-container">
      <Carousel snap-align="start" :items-to-scroll="1" :breakpoints="breakpoints" :wrap-around="true">
        <Slide v-for="(item, idx) in result" :key="idx" class="!block cursor-pointer grid gap-x-6">
          <BrowsejobsJobCard impression-source="featured" :item="item" :job-id="item.job_id" class="text-left" />
        </Slide>
        <template #addons>
          <Navigation class="!hidden !md:block" />
        </template>
      </Carousel>
    </div>
    <div v-if="props.datas?.button_label" class="flex mt-6">
      <BaseAtomsButton :to="props.datas?.button_url" outline size="sm" :class="`w-full md:w-auto min-w-xs px-4 py-2.5 font-bold hover:bg-primary-600/10 hover:text-primary-600 m${props.datas?.button_position === 'left' ? 'r' : (props.datas?.button_position === 'right' ? 'l' : 'x')}-auto`">
        {{ props.datas?.button_label }}
      </BaseAtomsButton>
    </div>
  </div>
</template>

<style scoped>
#carousel-container :deep(.carousel__prev), #carousel-container :deep(.carousel__next){
  border: 1px solid #5843E5 !important;
  border-radius: 8px !important;
  background: #fff;
  width: 28px;
  height: 28px;
}
#carousel-container :deep(.carousel__prev svg), #carousel-container :deep(.carousel__next svg){
  color: #5843E5;
  width: 24px;
  height: 24px;
}
#carousel-container :deep(.carousel__prev){
  margin-left: -24px;
}
#carousel-container :deep(.carousel__next){
  margin-right: -24px;
}
#carousel-container :deep(.carousel) {
    width: calc(100% + 16px);
    transform: translateX(-8px)
}
#carousel-container :deep(.carousel__slide) {
    padding-left: 8px;
    padding-right: 8px;
}
</style>
